export const normalizeFilter = (filter) => {

    if (filter) {

        if (Array.isArray(filter)) {
            return filter;
        } else {
            return [filter]
        }

    } else {
        return [];
    }

}

export const notificationLevels = [
    {text: 'Critical', value: 'CRITICAL'},
    {text: 'Info', value: 'INFO'},
    {text: 'Warning', value: 'WARNING'}];

export const notificationsTypes = [
    {text: 'Alert', value: 'ALERT_FIRED'},
    {text: 'Backup finished', value: 'BACKUP_FINISHED'}
];

export const OPERATORS = {
    EQUALS: {name: 'equals', inputType: 'text'},
    NOT_EQUALS: {name: 'not equals', inputType: 'text'},
    CONTAINS: {name: 'contains', inputType: 'text'},
    STARTS_WITH: {name: 'starts with', inputType: 'text'},
    ENDS_WITH: {name: 'ends with', inputType: 'text'},
    IS_EMPTY: {name: 'is empty'},
    IS_NOT_EMPTY: {name: 'is not empty'},
    IS_NULL: {name: 'is null'},
    IS_NOT_NULL: {name: 'is not null'},
    NUMBER_EQUALS: {name: 'number equals', inputType: 'number'},
    NUMBER_NOT_EQUALS: {name: 'number not equals', inputType: 'number'},
    GREATER_THAN: {name: 'greater than', inputType: 'number'},
    GREATER_THAN_OR_EQUAL: {name: 'greater than or equal to', inputType: 'number'},
    LESS_THAN: {name: 'less than', inputType: 'number'},
    LESS_THAN_OR_EQUAL: {name: 'less than or equal to', inputType: 'number'},
    IS_TRUE: {name: 'is true'},
    IS_FALSE: {name: 'is false'},
    BEFORE: {name: 'before', inputType: 'date'},
    AFTER: {name: 'after', inputType: 'date'},
    DATE_EQUALS: {name: 'date equals', inputType: 'date'},
    DATE_NOT_EQUALS: {name: 'date not equals', inputType: 'date'},
    TIMESTAMP_BEFORE: {name: 'before', inputType: 'timestamp'},
    TIMESTAMP_AFTER: {name: 'after', inputType: 'timestamp'},
    TIMESTAMP_EQUALS: {name: 'timestamp equals', inputType: 'timestamp'},
    TIMESTAMP_NOT_EQUALS: {name: 'timestamp not equals', inputType: 'timestamp'},
    TIME_BEFORE: {name: 'before', inputType: 'time'},
    TIME_AFTER: {name: 'after', inputType: 'time'},
    TIME_EQUALS: {name: 'time equals', inputType: 'time'},
    TIME_NOT_EQUALS: {name: 'time not equals', inputType: 'time'},
};

export const getFiltersByType = (type) => {

    switch (type) {
        case "VARCHAR":
            return [OPERATORS.EQUALS,
                OPERATORS.NOT_EQUALS,
                OPERATORS.CONTAINS,
                OPERATORS.STARTS_WITH,
                OPERATORS.ENDS_WITH,
                OPERATORS.IS_EMPTY,
                OPERATORS.IS_NOT_EMPTY,
                OPERATORS.IS_NULL,
                OPERATORS.IS_NOT_NULL
            ];
        case "BIGINT":
        case "DECIMAL":
        case "DOUBLE":
            return [
                OPERATORS.NUMBER_EQUALS,
                OPERATORS.NUMBER_NOT_EQUALS,
                OPERATORS.IS_NULL,
                OPERATORS.IS_NOT_NULL,
                OPERATORS.GREATER_THAN,
                OPERATORS.GREATER_THAN_OR_EQUAL,
                OPERATORS.LESS_THAN,
                OPERATORS.LESS_THAN_OR_EQUAL
            ]
        case "BOOLEAN":
            return [
                OPERATORS.EQUALS,
                OPERATORS.NOT_EQUALS,
                OPERATORS.IS_NULL,
                OPERATORS.IS_NOT_NULL,
                OPERATORS.IS_TRUE,
                OPERATORS.IS_FALSE
            ];
        case "DATE":
            return [
                OPERATORS.DATE_EQUALS,
                OPERATORS.DATE_NOT_EQUALS,
                OPERATORS.IS_NULL,
                OPERATORS.IS_NOT_NULL,
                OPERATORS.BEFORE,
                OPERATORS.AFTER
            ];
        case "TIMESTAMP":
            return [
                OPERATORS.TIMESTAMP_EQUALS,
                OPERATORS.TIMESTAMP_NOT_EQUALS,
                OPERATORS.IS_NULL,
                OPERATORS.IS_NOT_NULL,
                OPERATORS.TIMESTAMP_BEFORE,
                OPERATORS.TIMESTAMP_AFTER
            ];
        case "TIME":
            return [
                OPERATORS.TIME_EQUALS,
                OPERATORS.TIME_NOT_EQUALS,
                OPERATORS.IS_NULL,
                OPERATORS.IS_NOT_NULL,
                OPERATORS.TIME_BEFORE,
                OPERATORS.TIME_AFTER
            ];
        default:
            console.warn("Unknown type for filter: ", type);
            return [];
    }

}
